// MF entry exposed as ./AppMount for hosts that import the remote directly (no src/index.js, no dev self-mount).
import { loadAppSettings } from './appSettings';

// Settings the app can't boot without; validated up front to fail fast with a clear message.
const REQUIRED_SETTINGS = ['AUTHENTICATION_AUTHORITY', 'CLIENT_ID', 'CLIENT_SCOPE', 'CUSTOMERS_API', 'MFE_ROOT_ROUTE'];

/** Load settings and validate required keys (throws listing any missing). */
export async function prepareRuntime(action) {
  const appSettings = await loadAppSettings();

  const missing = REQUIRED_SETTINGS.filter((key) => typeof appSettings[key] !== 'string' || !appSettings[key].trim());
  if (missing.length) {
    throw new Error(`[customers-ui] cannot ${action}: missing required app settings: ${missing.join(', ')}`);
  }
}

/** Mount into a host-provided element; returns the bootloader's unmount fn. */
export const mount = async (args = {}) => {
  await prepareRuntime('mount');
  const { mount: appMount } = await import('./bootloader');
  return appMount(args);
};
